<template>
  <div
    ref="pageRef"
    class="w-full h-full"
  >
    <div class="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[800px]">
      <img
        src="../../assets/img/vrSpace.png"
        class="w-full h-full object-cover z-0"
      />
      <div class="absolute bottom-4 sm:bottom-8 md:bottom-[49px] left-0 right-0 w-full h-full z-10 flex flex-col items-center justify-end px-4">
        <div class="text-white text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-black text-center leading-none lg:mb-[73px] mb-6">
          VR大空间方案
        </div>

        <div class="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-[36px] font-[w400] text-center leading-none m-0 z-20">
          一站式综合解决方案，为各行业打造沉浸式全新体验。
        </div>
        <div class="h-2 sm:h-3 md:h-4 lg:h-[17px] w-full max-w-[300px] sm:max-w-[500px] md:max-w-[800px] lg:max-w-[1199px] bg-[#0BE0BB] rounded-2xl -mt-2 sm:-mt-3 md:-mt-[12px]"></div>
      </div>
    </div>

    <!-- VR大空间方案背景横幅 -->
    <div
      class="w-full relative  vr-banner-section"
      :style="{ backgroundImage: `url(${vrbgImg})` }"
    >

      <!-- 解决方案详情部分 -->
      <div class="w-full lg:pt-[91px] pt-8 lg:pb-[194px] pb-12">
        <div class="container mx-auto">
          <div
            v-for="(item, index) in solutionSections"
            :key="index"
            class="solution-section mb-12 sm:mb-16 md:mb-20 scroll-fade-in h-[407px]"
            :class="[
              index % 2 === 0 ? 'solution-section-left' : 'solution-section-right',
              index === solutionSections.length - 1 ? 'lg:mb-0' : 'lg:mb-[284px]'
            ]"
          >
            <div class="flex flex-col md:flex-row items-center md:items-stretch gap-6 sm:gap-8 md:gap-[82px] h-full">
              <!-- 图片部分：限制高度不超出父布局，图片保持宽高比不裁剪 -->
              <div
                class="w-full md:w-1/2 flex-shrink-0 h-full max-h-[407px] rounded-lg flex items-center justify-center"
                :class="index % 2 === 0 ? 'md:order-1' : 'md:order-2'"
              >
                <img
                  v-if="item.image"
                  :src="item.image"
                  :alt="item.title"
                  class="max-w-full max-h-[407px] w-auto h-auto object-contain rounded-lg"
                />
              </div>
              <!-- 文字内容部分：高度撑满，占位 div 填满剩余空间，按钮贴底 -->
              <div
                class="w-full md:w-1/2 flex flex-col h-full min-h-0"
                :class="index % 2 === 0 ? 'md:order-2' : 'md:order-1'"
              >
                <h2 class="text-white text-xl  md:text-2xl lg:text-4xl font-normal mb-4 sm:mb-[28px] leading-tight">
                  {{ item.title }}
                </h2>
                <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl font-normal mb-2 sm:mb-[12px]">{{ item.subTitle }}</p>
                <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl font-normal mb-6 sm:mb-8">
                  {{ item.description }}
                </p>
                <div class="flex-1 min-h-0"></div>
                <button
                  @click="handleApply"
                  class="solution-apply-btn cursor-pointer self-start px-6 sm:px-8 py-2 sm:py-3 border-2 border-white rounded-lg text-white text-sm sm:text-base md:text-[24px] font-bold hover:bg-[#0BE0BB] hover:text-[#15184F] transition-all duration-300"
                >
                  申请详细方案
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- #15184F bg-[#15184F] -->
    <div class="bg-[#15184F] w-full flex flex-col items-center justify-center
    lg:pb-[68px] pb-8
    ">
      <img
        src="../../assets/img/vrTitle.webp"
        class="lg:mt-[57px] mt-8  lg:mb-[68px] mb-8 scroll-fade-in"
      >

      <!-- 第一排：六边形服务卡片 -->
      <div class="flex flex-wrap justify-center items-start
      gap-2 lg:gap-[14px] px-4 pb-8 sm:pb-12 md:pb-16 lg:pb-[60px]">
        <div
          v-for="(item, index) in serviceCards"
          :key="index"
          class="hexagon-card scroll-fade-in"
          :style="{ '--delay': (index * 100) + 'ms' }"
        >
          <div class="hexagon-content">
            <img
              v-if="item.image"
              :src="item.image"
              :alt="item.title"
              class="hexagon-image"
            />
            <div class="hexagon-text-overlay">
              <p class="text-white lg:text-2xl text-base font-bold text-center mb-2
              ">{{ item.title }}</p>
              <p class="text-white lg:text-[20px] text-sm font-400 text-center">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二排：矩形应用场景按钮 -->
      <div class="flex flex-wrap justify-center items-center 
      gap-4 sm:gap-6 md:gap-8 lg:gap-10 px-4 pb-12 sm:pb-16 md:pb-20 lg:pb-[80px]">
        <div
          v-for="(item, index) in scenarioButtons"
          :key="index"
          class="scenario-button scroll-fade-in"
          :style="{ '--delay': (index * 100 + 500) + 'ms' }"
        >

          <div class="scenario-title">{{ item.title }}</div>
          <div
            v-if="item.subtitle"
            class="scenario-subtitle"
          >{{ item.subtitle }}</div>

        </div>
      </div>
      <div class="text-white text-2xl font-normal text-center">方案服务</div>
      <img
        src="../../assets/img/vrService.webp"
        class="w-full h-full 
        lg:h-[550px]
        lg:w-[998px]"
        style="object-fit: contain;"
      />
    </div>
    <!-- 应用案例 -->
    <div class="bg-[#0C3D8E] w-full pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-6 sm:pb-8  lg:pb-10">
      <div class="flex flex-col items-center justify-center">
        <img
          src="../../assets/img/appCases.webp"
          class="pb-6 sm:pb-8 md:pb-10 lg:pb-[46px] max-w-[100px] sm:max-w-[122px] md:max-w-[144px] scroll-fade-in"
        >

        <!-- 案例卡片 -->
        <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-[16px] flex-wrap px-4 max-w-[1500px] w-full">
          <!-- 前三个案例卡片 -->
          <div
            v-for="(item, index) in serviceCaseList"
            :key="index"
            class="relative w-full h-[280px] sm:h-[300px] md:h-[320px] lg:h-[340px] rounded-[8px]  overflow-hidden cursor-pointer transition-transform duration-500 ease-out hover:scale-[1.03] hover:shadow-[0_0_24px_rgba(41,255,248,0.25)]"
            :class="index % 2 === 0 ? 'scroll-fade-in-left' : 'scroll-fade-in-right'"
            :style="{ transitionDelay: (index * 40) + 'ms' }"
            @click="goToCaseDetail(item.id)"
          >
            <!-- 背景图片 -->
            <img
              :src="item.image"
              :alt="item.title"
              class="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-105"
            >
            <!-- 下半部分透明遮罩层 -->
            <div class="absolute bottom-0 left-0 right-0 h-[40%] bg-gradient-to-t from-[#07409D] to-[#FFFFFF]/50"></div>
            <!-- 文字内容 -->
            <div class="absolute bottom-0 left-0 right-0 p-3 sm:p-4 pb-[12px] pl-6 flex flex-col">
              <div class="text-white text-[14px] sm:text-[16px] md:text-[18px] font-black mb-1 sm:mb-[4px] truncate">{{ item.title }}</div>
              <p class="text-white/90 title-family-12 text-[12px] sm:text-[13px] md:text-[14px] leading-relaxed mb-2 sm:mb-3 line-clamp-2">{{ item.description }}</p>
              <a
                @click.prevent="goToCaseDetail(item.id)"
                :href="item.link"
                class="text-[#29FFF8] font-normal sm:text-[13px] md:text-[14px] hover:opacity-80 transition-opacity self-start"
              >查看详情>>></a>
            </div>
          </div>
          <!-- 第四个：查看更多卡片 -->
          <div
            class="relative w-full h-[280px] sm:h-[300px] md:h-[320px] lg:h-[340px] rounded-[8px] cursor-pointer transition-transform duration-500 ease-out hover:scale-[1.03] hover:shadow-[0_0_24px_rgba(41,255,248,0.25)] scroll-fade-in-right more-case-card"
            style="overflow: visible; background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(7, 64, 157, 1));"
            :style="{ transitionDelay: '120ms' }"
            @click="goToServicePage"
          >

            <!-- 内容区域 -->
            <div class="absolute inset-0 flex flex-col items-center justify-center">
              <!-- 虚线圆形边框和箭头图标 -->
              <div
                class="relative w-[168px] h-[168px] flex flex-col items-center justify-center mb-3 sm:mb-4"
                style="overflow: visible;"
              >
                <!-- 虚线圆形边框 -->
                <svg
                  viewBox="0 0 100 100"
                  width="168"
                  height="168"
                  preserveAspectRatio="xMidYMid meet"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); overflow: visible;"
                >
                  <circle
                    cx="50"
                    cy="50"
                    r="50"
                    fill="none"
                    stroke="rgba(147, 178, 229, 1)"
                    stroke-width="2"
                    stroke-dasharray="4,4"
                  />
                </svg>
                <!-- 三个右箭头 -->
                <img
                  src="../../assets/img/more.webp"
                  alt="right-arrow"
                  class="lg:mt-[45px] lg:mb-[9px]"
                >
                <!-- 查看更多文字 -->
                <div class="text-white text-sm font-400">查看更多</div>
              </div>

            </div>
          </div>
        </div>
        <!-- 立即咨询按钮 -->
        <button
          class="
          lg:py-[13px] lg:px-[47px] px-6 py-3  border-2 border-[#FFFFFF] rounded-xl 
          lg:rounded-[16px] text-[#29FFF8] text-base sm:text-lg md:text-xl 
          lg:text-[24px] font-bold hover:bg-[#0F5A7F] hover:border-[#A8B5D0] 
          lg:mt-[50px] mt-8 cursor-pointer
          transition-all duration-300 scroll-fade-in"
          style="background-color: rgba(11, 224, 187, 0.2);"
          @click="handleJoin"
        >
          申请加盟
        </button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { serviceApi } from "@/api";
import { RequestError } from "@/utils/request";
import wenboImg from "@/assets/img/wenbo.png";
import wenchuangImg from "@/assets/img/wenchuang.png";
import wenlvImg from "@/assets/img/wenlv.png";
import yuleImg from "@/assets/img/yule.png";
import chuanchengImg from "@/assets/img/chuancheng.png";
import vrbgImg from "@/assets/img/vrbg.webp";
import vr1Img from "@/assets/img/vr1.webp";
import vr2Img from "@/assets/img/vr2.webp";
import vr3Img from "@/assets/img/vr3.webp";
import vr4Img from "@/assets/img/vr4.webp";

const pageRef = ref<HTMLElement | null>(null);
let scrollFadeObserver: IntersectionObserver | null = null;
const router = useRouter();

onMounted(() => {
  setupScrollFadeObserver();
  loadServiceCaseList();
});

onBeforeUnmount(() => {
  scrollFadeObserver?.disconnect();
  scrollFadeObserver = null;
});

const setupScrollFadeObserver = async () => {
  await nextTick();
  const root = pageRef.value;
  if (!root) return;

  const elements = Array.from(
    root.querySelectorAll<HTMLElement>(
      ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right, .solution-section"
    )
  );
  if (elements.length === 0) return;

  if (!("IntersectionObserver" in window)) {
    elements.forEach((el) => el.classList.add("fade-in-visible"));
    return;
  }

  scrollFadeObserver?.disconnect();
  scrollFadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        (entry.target as HTMLElement).classList.add("fade-in-visible");
        scrollFadeObserver?.unobserve(entry.target);
      });
    },
    {
      root: null,
      threshold: 0.15,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  elements.forEach((el) => scrollFadeObserver?.observe(el));
};

// 服务案例数据接口
interface ServiceCaseItem {
  image: string;
  title: string;
  description: string;
  link: string;
  id: string;
}

// 服务案例列表数据（接口获取，默认取前 3 个）
const serviceCaseList = ref<ServiceCaseItem[]>([]);

// 六边形服务卡片数据
interface ServiceCard {
  title: string;
  description: string;
  image?: string;
}

const serviceCards = ref<ServiceCard[]>([
  {
    title: "文博体验",
    description: "数字艺术展演+文化IP开发,非遗技艺传承近在眼前",
    image: wenboImg,
  },
  {
    title: "文创科普",
    description: "文化感知重构+认知范式创新,寓教于乐形成深刻记忆",
    image: wenchuangImg,
  },
  {
    title: "文旅营销",
    description: "线上引流转化+线下体验留存,虚实融合的营销闭环",
    image: wenlvImg,
  },
  {
    title: "娱乐互动",
    description: "打造奇幻的主题体验,让游客在元宇宙中尽情冒险和娱乐",
    image: yuleImg,
  },
  {
    title: "VR红色传承",
    description: '以"历史参与者"身份重走长征路,触发情感共鸣',
    image: chuanchengImg,
  },
]);

// 应用场景按钮数据
interface ScenarioButton {
  title: string;
  subtitle?: string;
  image?: string;
}

const scenarioButtons = ref<ScenarioButton[]>([
  {
    title: "博物馆/科技馆",
    subtitle: "海洋馆/图书馆",
  },
  {
    title: "文旅景区",
  },
  {
    title: "商场/商业综合体",
  },
  {
    title: "研学基地",
  },
]);

// 解决方案详情部分数据
interface SolutionSection {
  title: string;
  subTitle: string;
  description: string;
  image?: string;
}

const solutionSections = ref<SolutionSection[]>([
  {
    title: "大空间LBE多人实时互动解决方案",
    subTitle: "大型商业综合体｜旅游景区｜VR沉浸式影院｜",
    description:
      "多人实时互动解决方案正迅速成为沉浸式娱乐的新标准，这种解决方案通过结合先进的硬件设备和创新的软件技术，为用户提供了一个全新的社交和娱乐平台。赋能文旅、商业地产、影院以及新消费领域，打造高坪效、极具沉浸感官的全新形态体验展。",
    image: vr1Img,
  },
  {
    title: "XR/MR 大空间播控系统解决方案",
    subTitle: "多设备统一调度｜场景内容一键切换｜互动流程智能管控｜",
    description:
      "为沉浸式 LBE 大空间打造的一体化智能播控中枢解决方案，聚焦大空间场景下多设备协同、多内容调度、多体验管控的核心需求，构建起覆盖 “硬件接入 - 内容播控 - 场景调度 - 数据监测 - 运维管理” 的全链路智能管控体系。",
    image: vr2Img,
  },
  {
    title: "不同规模场地 VR 大空间定制部署解决方案",
    subTitle: "小型体验区＜50㎡｜中型体验区 50-200㎡｜大型体验区＞200㎡｜",
    description:
      "为各规模场地量身设计适配性的硬件部署方案、体验动线规划、虚实场景精准映射方案与安全防护布局，兼顾场地空间利用率、体验沉浸感与运营便捷性，支持无破坏式场地改造、轻量化快速搭建、规模化场景定制搭建等多种落地形式",
    image: vr3Img,
  },
  {
    title: "售后与技术服务解决方案",
    subTitle: "运营人员实操培训｜7×24 小时远程技术支持｜",
    description:
      "提供全周期技术保障，含驻场调试、7×24小时远程支持、设备全生命周期维保，配套运营/技术人员实操培训，兼顾故障快速排查、硬件升级适配与内容迭代支持，全方位保障项目稳定运营。",
    image: vr4Img,
  },
]);

type CaseRaw = {
  id: string;
  title: string;
  image: string;
  content: string;
  address: string;
};

// 随机打乱数组并取前n个
const shuffleArray = <T>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j] as T, shuffled[i] as T];
  }
  return shuffled;
};

const loadServiceCaseList = async () => {
  try {
    const res = await serviceApi.getCaseList();
    const list = (res.data || []) as CaseRaw[];
    // 随机选择3个案例
    const shuffledList = shuffleArray(list);
    serviceCaseList.value = shuffledList.slice(0, 3).map((item) => ({
      id: item.id,
      title: item.title ?? "",
      description: item.content ?? "",
      image: item.image || "",
      link: "#",
    }));

    await nextTick();
    // 重新观察新加载的服务案例卡片（包含左右飞入动画）
    setupScrollFadeObserver();
  } catch (error) {
    console.error("加载服务案例失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
    serviceCaseList.value = [];
  }
};

// 跳转到案例详情页
const goToCaseDetail = (id: string) => {
  if (!id) return;
  router.push(`/service/case/${id}.html`);
};

// 跳转到服务页面
const goToServicePage = () => {
  router.push("/service");
};

// 爱番番独立沟通链接（PC / 移动端）
const AFFIM_CHAT_URL_PC =
  "https://affim.baidu.com/unique_76738406/chat?siteId=22754352&userId=76738406&siteToken=0d1814da8c0c617ae6ea195eae32d27e";
const AFFIM_CHAT_URL_MOBILE =
  "https://affim.baidu.com/unique_76738406/mobile/chat?siteId=22754352&userId=76738406&siteToken=0d1814da8c0c617ae6ea195eae32d27e";

// 申请详细方案
const handleApply = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth < 768;
  const url = isMobile ? AFFIM_CHAT_URL_MOBILE : AFFIM_CHAT_URL_PC;
  window.open(url, "_blank", "noopener,noreferrer");
};

// 申请加盟 - 跳转到联系我们页面
const handleJoin = () => {
  router.push("/contact.html");
};
</script>

<style scoped>
/* VR横幅部分样式 */
.vr-banner-section {
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 400px;
  width: 100%;
}

@media (min-width: 768px) {
  .vr-banner-section {
    min-height: 500px;
  }
}

@media (min-width: 1024px) {
  .vr-banner-section {
    min-height: 600px;
  }
}

/* 解决方案部分样式 */
.solution-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.solution-section.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

.solution-apply-btn {
  background-color: rgba(11, 224, 187, 0.2);
  border-color: white;
  color: rgba(41, 255, 248, 1);
}

.solution-apply-btn:hover {
  background: #0be0bb;
  color: #15184f;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(11, 224, 187, 0.3);
}
/* 滚动飞入（scroll-fade-in）需要 JS 追加 fade-in-visible 才会触发 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  transition-delay: var(--delay, 0ms);
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  transition-delay: var(--delay, 0ms);
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  transition-delay: var(--delay, 0ms);
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

.tech-title-card {
  background: linear-gradient(180deg, #5fd3ff 0%, #b248ff 100%);
  border-radius: 16px;
  padding: 12px 24px;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  font-family: "Noto Sans SC", sans-serif;
  white-space: nowrap;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.tech-title-cardsp {
  background: linear-gradient(180deg, #5fd3ff 0%, #b248ff 100%);
  border-radius: 16px;
  padding: 12px 24px;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  font-family: "Noto Sans SC", sans-serif;
  white-space: nowrap;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}
@media (min-width: 768px) {
  .tech-title-card {
    border-radius: 24px;
    padding: 18px 36px;
    font-size: 22px;
  }
  .tech-title-cardsp {
    padding: 12px 24px;
  }
}

@media (min-width: 1024px) {
  .tech-title-card {
    border-radius: 32px;
    padding: 35px 0px;
    font-size: 24px;
    font-weight: blod;
  }
  .tech-title-cardsp {
    padding: 35px 34px;
  }
}

.tech-title-card-mobile {
  background: linear-gradient(180deg, #5fd3ff 0%, #b248ff 100%);
  border-radius: 16px;
  padding: 16px 20px;
  text-align: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  font-family: "Noto Sans SC", sans-serif;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  white-space: normal;
  word-break: break-word;
}

@media (min-width: 640px) {
  .tech-title-card-mobile {
    font-size: 16px;
    padding: 18px 24px;
  }
}

/* 发光下划线 */
.glowing-underline {
  width: 100%;
  max-width: 800px;
  height: 4px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(138, 43, 226, 0.8) 20%,
    rgba(75, 0, 130, 0.9) 40%,
    rgba(138, 43, 226, 0.8) 60%,
    transparent 100%
  );
  box-shadow: 0 0 10px rgba(138, 43, 226, 0.6), 0 0 20px rgba(75, 0, 130, 0.4),
    0 0 30px rgba(138, 43, 226, 0.3);
  border-radius: 2px;
  margin-top: 8px;
}

@media (min-width: 768px) {
  .glowing-underline {
    height: 5px;
    max-width: 1000px;
  }
}

@media (min-width: 1024px) {
  .glowing-underline {
    height: 6px;
    max-width: 1200px;
  }
}

/* 六边形服务卡片 */
.hexagon-card {
  position: relative;
  width: 160px;
  height: 180px;
  margin: 15px 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.hexagon-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 32px;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  overflow: hidden;
}

.hexagon-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.hexagon-text-overlay {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.hexagon-image-placeholder {
  width: 100%;
  height: 60px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 640px) {
  .hexagon-card {
    width: 200px;
    height: 220px;
  }
}

@media (min-width: 768px) {
  .hexagon-card {
    width: 220px;
    height: 240px;
  }
}

@media (min-width: 1024px) {
  .hexagon-card {
    width: 272px;
    height: 272px;
  }
}

/* 矩形应用场景按钮 */
.scenario-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 200px;
  height: 120px;
  border-radius: 16px;
  border: 1px solid #935a99;

  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.scenario-button:hover {
  background: rgba(30, 40, 80, 0.8);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 15px rgba(138, 43, 226, 0.4);
  transform: translateY(-2px);
}

.scenario-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 120px;
}

.scenario-title {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
  line-height: 1.4;
}

.scenario-subtitle {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin-top: 5px;
}

.scenario-image-placeholder {
  width: 100%;
  height: 80px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scenario-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

@media (min-width: 640px) {
  .scenario-button {
    min-width: 300px;
    padding: 30px 90px;
  }
  .scenario-title {
    font-size: 18px;
  }
  .scenario-subtitle {
    font-size: 18px;
  }
}

@media (min-width: 768px) {
  .scenario-button {
    min-width: 240px;
    padding: 30px 90px;
  }
  .scenario-title {
    font-size: 20px;
  }
}

@media (min-width: 1024px) {
  .scenario-button {
    min-width: 260px;
    padding: 30px 90px;
  }
  .scenario-title {
    font-size: 24px;
  }
}

/* 方案服务区域 */
.solution-service-section {
  position: relative;
  width: 100%;
  padding: 60px 20px 120px;
  overflow: hidden;
  background: #1f0d40;
  background-image: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 20px,
      rgba(138, 43, 226, 0.03) 20px,
      rgba(138, 43, 226, 0.03) 21px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 20px,
      rgba(75, 0, 130, 0.03) 20px,
      rgba(75, 0, 130, 0.03) 21px
    );
  background-size: 100px 100px, 100px 100px;
  background-position: 0 0, 50px 50px;
}

/* 背景光点效果 */
.solution-background-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(
      circle at 20% 30%,
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(138, 43, 226, 0.08) 1px,
      transparent 1px
    ),
    radial-gradient(
      circle at 50% 50%,
      rgba(255, 255, 255, 0.03) 1px,
      transparent 1px
    ),
    radial-gradient(
      circle at 10% 80%,
      rgba(138, 43, 226, 0.06) 1px,
      transparent 1px
    ),
    radial-gradient(
      circle at 90% 20%,
      rgba(255, 255, 255, 0.04) 1px,
      transparent 1px
    );
  background-size: 200px 200px, 300px 300px, 250px 250px, 180px 180px,
    220px 220px;
  opacity: 0.6;
  pointer-events: none;
  z-index: 0;
}

.solution-service-title {
  position: relative;
  z-index: 1;
  color: white;
  font-size: 28px;
  font-weight: normal;
  text-align: center;
  margin-bottom: 80px;
}

@media (min-width: 768px) {
  .solution-service-title {
    font-size: 32px;
    margin-bottom: 100px;
  }
}

@media (min-width: 1024px) {
  .solution-service-title {
    font-size: 36px;
    margin-bottom: 120px;
  }
}

/* 方案服务卡片容器 */
.solution-cards-container {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 800px;
  padding: 40px 20px;
}

@media (min-width: 768px) {
  .solution-cards-container {
    min-height: 900px;
  }
}

@media (min-width: 1024px) {
  .solution-cards-container {
    min-height: 1000px;
  }
}

/* 每个解决方案项 */
.solution-item {
  position: absolute;
  z-index: 2;
}

/* 卡片01 (左上) */
.solution-item-01 {
  top: 5%;
  left: 5%;
}

/* 卡片03 (右上) */
.solution-item-03 {
  top: 5%;
  right: 5%;
}

/* 卡片02 (下方中央偏右) */
.solution-item-02 {
  bottom: 10%;
  left: 55%;
  transform: translateX(-50%);
}

@media (min-width: 768px) {
  .solution-item-01 {
    top: 8%;
    left: 8%;
  }
  .solution-item-03 {
    top: 8%;
    right: 8%;
  }
  .solution-item-02 {
    bottom: 8%;
    left: 58%;
  }
}

@media (min-width: 1024px) {
  .solution-item-01 {
    top: 10%;
    left: 10%;
  }
  .solution-item-03 {
    top: 10%;
    right: 10%;
  }
  .solution-item-02 {
    bottom: 10%;
    left: 60%;
  }
}

/* 方案服务六边形卡片 */
.solution-hexagon-card {
  position: relative;
  width: 280px;
  height: 320px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.solution-hexagon-card:hover {
  transform: scale(1.05);
}

/* 六边形发光边框 */
.solution-hexagon-card::before {
  content: "";
  position: absolute;
  top: -3px;
  left: -3px;
  width: calc(100% + 6px);
  height: calc(100% + 6px);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  background: rgba(138, 43, 226, 0.9);
  filter: blur(3px);
  opacity: 0.9;
  z-index: 0;
  box-shadow: 0 0 15px rgba(138, 43, 226, 0.8), 0 0 30px rgba(138, 43, 226, 0.6),
    0 0 45px rgba(138, 43, 226, 0.4);
}

/* 六边形边框 */
.solution-hexagon-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  border: 3px solid rgba(138, 43, 226, 0.9);
  box-shadow: inset 0 0 20px rgba(138, 43, 226, 0.3),
    0 0 20px rgba(138, 43, 226, 0.6);
  z-index: 1;
  pointer-events: none;
}

.solution-hexagon-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 30px 40px;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  background: rgba(50, 20, 80, 0.6);
}

/* 半透明数字（带发光效果） */
.solution-number {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 90px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.25);
  z-index: 1;
  pointer-events: none;
  font-family: Arial, sans-serif;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  filter: blur(0.5px);
}

.solution-title {
  color: white;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
  z-index: 2;
  position: relative;
}

.solution-image-placeholder {
  width: 100%;
  height: 100px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: relative;
}

.solution-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 连接线 */
.solution-connector {
  position: absolute;
  width: 2px;
  background: rgba(138, 43, 226, 0.9);
  box-shadow: 0 0 8px rgba(138, 43, 226, 0.8), 0 0 15px rgba(138, 43, 226, 0.6),
    0 0 25px rgba(138, 43, 226, 0.4);
  z-index: 1;
  pointer-events: none;
}

/* 卡片01的连接线（向右下方） */
.solution-connector-01 {
  height: 200px;
  top: calc(100% + 10px);
  left: 65%;
  transform: rotate(30deg);
  transform-origin: top center;
}

/* 卡片03的连接线（向左下方） */
.solution-connector-03 {
  height: 200px;
  top: calc(100% + 10px);
  right: 65%;
  transform: rotate(-30deg);
  transform-origin: top center;
}

/* 卡片02的连接线（向左上方） */
.solution-connector-02 {
  height: 200px;
  bottom: calc(100% + 10px);
  left: 35%;
  transform: rotate(150deg);
  transform-origin: bottom center;
}

/* 描述文字 */
.solution-desc {
  position: absolute;
  color: white;
  font-size: 14px;
  line-height: 1.8;
  text-align: left;
  white-space: pre-line;
  z-index: 3;
  pointer-events: none;
  max-width: 280px;
}

/* 卡片01的描述文字（连接线末端） */
.solution-desc-01 {
  top: calc(100% + 220px);
  left: calc(65% + 100px);
}

/* 卡片03的描述文字（连接线末端） */
.solution-desc-03 {
  top: calc(100% + 220px);
  right: calc(65% + 100px);
  text-align: right;
}

/* 卡片02的描述文字（连接线末端） */
.solution-desc-02 {
  bottom: calc(100% + 220px);
  left: calc(35% - 100px);
  text-align: left;
}

@media (min-width: 640px) {
  .solution-hexagon-card {
    width: 300px;
    height: 340px;
  }
  .solution-number {
    font-size: 100px;
  }
  .solution-title {
    font-size: 22px;
  }
  .solution-desc {
    font-size: 15px;
    max-width: 300px;
  }
  .solution-connector-01,
  .solution-connector-03,
  .solution-connector-02 {
    height: 200px;
  }
}

@media (min-width: 768px) {
  .solution-hexagon-card {
    width: 320px;
    height: 360px;
  }
  .solution-number {
    font-size: 110px;
  }
  .solution-title {
    font-size: 24px;
  }
  .solution-desc {
    font-size: 16px;
    max-width: 320px;
  }
  .solution-connector-01,
  .solution-connector-03,
  .solution-connector-02 {
    height: 220px;
  }
}

@media (min-width: 1024px) {
  .solution-hexagon-card {
    width: 360px;
    height: 400px;
  }
  .solution-number {
    font-size: 130px;
  }
  .solution-title {
    font-size: 26px;
  }
  .solution-desc {
    font-size: 17px;
    max-width: 360px;
  }
  .solution-connector-01,
  .solution-connector-03,
  .solution-connector-02 {
    height: 240px;
  }
}
</style>